import { ENVIRONMENT_GLOBAL, SITE_CONFIG_GLOBAL } from './global';
ENVIRONMENT_GLOBAL.production = true;
export const environment = ENVIRONMENT_GLOBAL;

export const siteConfig = SITE_CONFIG_GLOBAL;
